import { render, staticRenderFns } from "./window-item-secondary.vue?vue&type=template&id=117f764c&scoped=true&"
import script from "./window-item-secondary.vue?vue&type=script&lang=js&"
export * from "./window-item-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117f764c",
  null
  
)

export default component.exports